
export default (amount, countryIsoCode) => {
  const companyCountryConfig = window.countries.find(x => x.iso_code === countryIsoCode)

  // use Company Country `language` because `front_config.i18n.lang` may be customized for SaaS specific translation and could not match to a real Locale
  return amount.toLocaleString(companyCountryConfig.language.replace('_', '-'), { style: 'currency', currency: companyCountryConfig.currency })
}
